import { Vestiging } from "@/entities/vestiging";
import { BaseFaciliteitenTable, StationHeader } from "../../shared";
import { createColumns } from "./columns-factory";

interface FaciliteitenDetailsForStationProps {
    stationCode: string;
    vestigingen: Vestiging[];
}

export function FaciliteitenDetailsForStation({ stationCode, vestigingen }: Readonly<FaciliteitenDetailsForStationProps>) {
    const columns = createColumns();

    return (
        <div className="space-y-4">
            <StationHeader stationCode={stationCode} />
            <BaseFaciliteitenTable
                stationCode={stationCode}
                vestigingen={vestigingen}
                columns={columns}
                columnWidths={["45%", "20%", "35%"]}
            />
        </div>
    );
}
